import React from "react";
import BannerTop from "../components/BannerTop";
import TeamRelys from "../components/TeamRelys";
import QuickAnswers from "../components/QuickAnswers";
import TextCarosul from "../components/TextCarosul";
import FinancialFooter from "../components/FinancialFooter";
import StandApart from "../components/StandApart";
import ProcessPage from "../components/ProcessPage";

const FinancialStatement = () => {
  return (
    <div className="flex flex-col h-auto">
      <BannerTop />
      <TeamRelys />
      {/* <UploadSteps /> */}
      <ProcessPage />
      <StandApart />
      <QuickAnswers />
      <TextCarosul />
      <FinancialFooter />
    </div>
  );
};

export default FinancialStatement;
